export default {
  meta: {
    title: '踩点宝视频播放页',
    url: '/passenger/videoPlay', // 埋点字段，上报归属的模块
    urlName: '踩点宝' // 埋点字段，上报归属的模块
  }
};
